<template>
  <div class="total">
    <MyHeader :menu-index="1" id="a1" />
    <!--背景图-->
    <div class="bg">
      <video
        preload="auto"
        :src="fileServerUrl + 'assets/bg/soldout.mp4'"
        autoplay="autoplay"
        loop="loop"
        muted="muted"
        id="sysp"
      />
      <!--<div class="ljgd tx hvr-icon-wobble-horizontal">
         <span @click="sign" style="letter-spacing: 0.01rem">{{
          $t("join_in_now")
        }}</span>
      </div>-->
    </div>
    <!--数字导航-->
    <div class="dt-num" style="margin-left: -25px">
      <div class="num-ui">
        <div class="ui-item">
          <img :src="fileServerUrl + 'assets/sold/LSDB.png'" />
        </div>
        <div class="ui-item">
          <img :src="fileServerUrl + 'assets/sold/LSPP.png'" />
        </div>
        <div class="ui-item">
          <img :src="fileServerUrl + 'assets/sold/ZZYZS.png'" />
        </div>
        <div class="ui-item">
          <img :src="fileServerUrl + 'assets/sold/YJJB.png'" />
        </div>
        <div class="ui-item">
          <img :src="fileServerUrl + 'assets/sold/ALFX.png'" />
        </div>
        <div class="ui-item">
          <img :src="fileServerUrl + 'assets/sold/TechShow.png'" />
        </div>
        <div class="ui-item">
          <img :src="fileServerUrl + 'assets/sold/HZSJ.png'" />
        </div>
      </div>
      <div class="num-dh" v-if="numItemShow">
        <div style="margin-left: 14%; display: flex">
          <div
            class="num-item tx"
            v-for="(item, index) in numItemList"
            :key="index"
          >
            <div>
              <div class="num-item-sz tx">
                <animate-number
                  :from="item.szFrom"
                  :to="item.szTo"
                  duration="2000"
                ></animate-number>
                <span v-if="index == 6" style="font-size: 0.2rem">{{
                  item.fh
                }}</span>
                <span v-else>{{ item.fh }}</span>
              </div>
              <div class="num-item-wz tx">
                <span>{{ item.wz }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--框架-->
    <div class="main">
      <div
        ref="huiyi"
        :class="{
          testhuiyi: true,
          testhuiyienter: aboutCoreShow,
          testhuiyileave: !aboutCoreShow,
        }"
      >
        <div class="wz-title">
          <span class="ty-title">{{ $t("new_inspiration") }}</span>
        </div>

        <div class="ty-font" style="margin-top: 4%">
          <p style="text-align: justify">
            {{ $t("new_inspiration_text") }}
          </p>
        </div>
      </div>
      <div class="ysc">
        <img class="xffd" :src="fileServerUrl + 'assets/bg/6.png'" />
      </div>

      <!--            <div class="double">
                <div class="double-tp" >
                    <img class="tp-img" :src="fileServerUrl+'assets/eight-lb/wz.jpg'"/>
                </div>

                <div class="double-wz ty-font" >
                    <p>
                        疫情三年影响的不仅仅是消费者消费意愿的强弱，更深刻改变了消费方式、消费选择和消费动机，且正在形成新的消费格局。
                    </p>
                    <p>
                        Sold Out新引响峰会是Smart Retail智慧零售峰会的升级品牌，沉淀六载，潜心将与200家中国零售商和品牌商合力聚焦消费格局新变化，全视角洞察新消费的转型与重塑。
                    </p>
                </div>
            </div>-->
    </div>
    <!--演讲嘉宾-->
    <div
      id="yjjb"
      style="margin-top: 5%"
      class="main"
      ref="jiabin"
      :class="{
        testhuiyi: true,
        testhuiyienter: aboutjiabin,
        testhuiyileave: !aboutjiabin,
      }"
    >
      <div class="wz-title">
        <span class="ty-title">{{ $t("series_spearker") }}</span>
      </div>
      <div class="speeker-info ty-font-speeker">
        <div class="row">
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout01.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers01") }}</span>
              <span>{{ $t("speakers01_text1") }}</span>
              <span>{{ $t("speakers01_text2") }}</span>
              <!-- <span>{{ $t("speakers1_text3") }}</span> -->
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout02.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers02") }}</span>
              <span>{{ $t("speakers02_text1") }}</span>
              <span>{{ $t("speakers02_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout03.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers03") }}</span>
              <span>{{ $t("speakers03_text1") }}</span>
              <span>{{ $t("speakers03_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout04.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers04") }}</span>
              <span>{{ $t("speakers04_text1") }}</span>
              <span>{{ $t("speakers04_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout05.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers05") }}</span>
              <span>{{ $t("speakers05_text1") }}</span>
              <span>{{ $t("speakers05_text2") }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout06.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers06") }}</span>
              <span>{{ $t("speakers06_text1") }}</span>
              <span>{{ $t("speakers06_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout07.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers07") }}</span>
              <span>{{ $t("speakers07_text1") }}</span>
              <span>{{ $t("speakers07_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout08.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers08") }}</span>
              <span>{{ $t("speakers08_text1") }}</span>
              <span>{{ $t("speakers08_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout09.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers09") }}</span>
              <span>{{ $t("speakers09_text1") }}</span>
              <span>{{ $t("speakers09_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout010.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers010") }}</span>
              <span>{{ $t("speakers010_text1") }}</span>
              <span>{{ $t("speakers010_text2") }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout011.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers011") }}</span>
              <span>{{ $t("speakers011_text1") }}</span>
              <span>{{ $t("speakers011_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout012.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers012") }}</span>
              <span>{{ $t("speakers012_text1") }}</span>
              <span>{{ $t("speakers012_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout013.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers013") }}</span>
              <span>{{ $t("speakers013_text1") }}</span>
              <span>{{ $t("speakers013_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout014.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers014") }}</span>
              <span>{{ $t("speakers014_text1") }}</span>
              <span>{{ $t("speakers014_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout015.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers015") }}</span>
              <span>{{ $t("speakers015_text1") }}</span>
              <span>{{ $t("speakers015_text2") }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout016.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers016") }}</span>
              <span>{{ $t("speakers016_text1") }}</span>
              <span>{{ $t("speakers016_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout017.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers017") }}</span>
              <span>{{ $t("speakers017_text1") }}</span>
              <span>{{ $t("speakers017_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout018.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers018") }}</span>
              <span>{{ $t("speakers018_text1") }}</span>
              <span>{{ $t("speakers018_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout019.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers019") }}</span>
              <span>{{ $t("speakers019_text1") }}</span>
              <span>{{ $t("speakers019_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout020.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers020") }}</span>
              <span>{{ $t("speakers020_text1") }}</span>
              <span>{{ $t("speakers020_text2") }}</span>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout021.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers021") }}</span>
              <span>{{ $t("speakers021_text1") }}</span>
              <span>{{ $t("speakers021_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout022.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers022") }}</span>
              <span>{{ $t("speakers022_text1") }}</span>
              <span>{{ $t("speakers022_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout023.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers023") }}</span>
              <span>{{ $t("speakers023_text1") }}</span>
              <span>{{ $t("speakers023_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout024.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers024") }}</span>
              <span>{{ $t("speakers024_text1") }}</span>
              <span>{{ $t("speakers024_text2") }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="cover">
              <img
                class="xffd"
                :src="fileServerUrl + 'assets/speaker/soldout025.jpg'"
              />
            </div>

            <div class="item-wz">
              <span class="speeker-name">{{ $t("speakers025") }}</span>
              <span>{{ $t("speakers025_text1") }}</span>
              <span>{{ $t("speakers025_text2") }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--轮播图-->
    <div style="margin-top: 8%; display: flex; flex-direction: column">
      <!--            <DemoLb class="demolb"/>-->
      <!--            要修改的内容-->
      <div class="hyld-tp">
        <div class="tp-item">
          <img :src="fileServerUrl + 'assets/eight-lb/4.png'" />
          <div class="tp-zzc">
            <span>{{ $t("nine_img1") }}</span>
          </div>
        </div>
        <div class="tp-item">
          <img :src="fileServerUrl + 'assets/eight-lb/5.png'" />
          <div class="tp-zzc">
            <span>{{ $t("nine_img2") }}</span>
          </div>
        </div>
        <div class="tp-item">
          <img :src="fileServerUrl + 'assets/eight-lb/3.png'" />
          <div class="tp-zzc">
            <span>{{ $t("nine_img3") }}</span>
          </div>
        </div>
      </div>
      <div class="hyld-tp">
        <div class="tp-item">
          <img :src="fileServerUrl + 'assets/eight-lb/10.png'" />
          <div class="tp-zzc">
            <span>{{ $t("nine_img4") }}</span>
          </div>
        </div>
        <div class="tp-item">
          <img :src="fileServerUrl + 'assets/eight-lb/9.png'" />
          <div class="tp-zzc">
            <span>{{ $t("nine_img5") }}</span>
          </div>
        </div>
        <div class="tp-item">
          <img :src="fileServerUrl + 'assets/eight-lb/6.png'" />
          <div class="tp-zzc">
            <span>{{ $t("nine_img6") }}</span>
          </div>
        </div>
      </div>
      <div class="hyld-tp">
        <div class="tp-item">
          <img :src="fileServerUrl + 'assets/eight-lb/7.png'" />
          <div class="tp-zzc">
            <span>{{ $t("nine_img7") }}</span>
          </div>
        </div>
        <div class="tp-item">
          <img :src="fileServerUrl + 'assets/eight-lb/1.png'" />
          <div class="tp-zzc">
            <span>{{ $t("nine_img8") }}</span>
          </div>
        </div>
        <div class="tp-item">
          <img :src="fileServerUrl + 'assets/eight-lb/2.png'" />
          <div class="tp-zzc">
            <span>{{ $t("nine_img9") }}</span>
          </div>
        </div>
      </div>
    </div>
    <!--赞助商-->
    <div
      class="main"
      style="margin-top: 5%"
      ref="zzs"
      :class="{
        testhuiyi: true,
        testhuiyienter: aboutzzs,
        testhuiyileave: !aboutzzs,
      }"
    >
      <div class="xlzz">
        <div class="wz-title">
          <span class="ty-title">{{ $t("sponsor") }}</span>
        </div>
        <div class="xlzz-bottom">
          <!--   41和69用的一个图片     这里有bug,第一个跑马灯总是显示不全，所以在这加一个隐藏的-->
          <Pmd :images="images1" hidden=""></Pmd>
          <Pmd :images="images1" style="margin-top: 20px"></Pmd>
          <Pmd :images="images2" :oushu="1" style="margin-top: 20px"></Pmd>
          <Pmd :images="images3" style="margin-top: 20px"></Pmd>
          <Pmd :images="images4" :oushu="1" style="margin-top: 20px"></Pmd>
          <Pmd :images="images5" style="margin-top: 20px"></Pmd>

          <div class="xlzz-bottom-xh"></div>
          <div class="xlzz-bottom-xh2"></div>
        </div>
      </div>
    </div>
    <div style="height: 100px"></div>
    <myfoot />
  </div>
</template>

<script>
import MyHeader from "@/components/MyHeader";
import Pmd from "@/components/Pmd";
import DemoLb from "@/views/DemoLb";
import myfoot from "@/components/MyFoot";

export default {
  components: { MyHeader, DemoLb, Pmd, myfoot },
  name: "HomeView2",
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  data() {
    return {
      fileServerUrl: fileServerUrl,
      numItemShow: false,
      aboutCoreShow: false,
      aboutjiabin: false,
      aboutzzs: false,

      numItemList: [
        {
          fh: "+",
          wz: "零售代表",
          szFrom: 3,
          szTo: 300,
          // image:"assets/images/dtnum-1.png",
        },
        {
          fh: "+",
          wz: "零售品牌",
          szFrom: 3,
          szTo: 100,
          // image: "assets/images/dt-num2.png",
        },
        {
          fh: "+",
          wz: "赞助与展商",
          szFrom: 3,
          szTo: 40,
          // image:"assets/images/dtnum-3.png"
        },
        {
          fh: "+",
          wz: "演讲嘉宾",
          szFrom: 3,
          szTo: 35,
          // image:"assets/images/dtnum-4.png",
        },
        {
          fh: "+",
          wz: "案例分享",
          szFrom: 3,
          szTo: 30,
          // image:"assets/images/dtnum-1.png",
        },
        {
          fh: "+",
          wz: "产品展示",
          szFrom: 3,
          szTo: 5,
          // image:"assets/images/dtnum-1.png",
        },
        {
          fh: "场",
          wz: "合作商机",
          szFrom: 1,
          szTo: 2,
          // image:"assets/images/dtnum-1.png",
        },
      ],
      // 一组跑马灯图片8个
      images1: [
        "assets/zzs/sold-012.png",
        "assets/zzs/new1.png",
        "assets/zzs/new2.png",
        "assets/zzs/new3.png",
        "assets/zzs/sold-01.png",
        "assets/zzs/sold-02.png",
        "assets/zzs/sold-03.png",
        "assets/zzs/sold-04.png",
        "assets/zzs/sold-012.png",
        "assets/zzs/sold-05.png",
        "assets/zzs/sold-06.png",
        "assets/zzs/sold-07.png",
        "assets/zzs/sold-08.png",
        "assets/zzs/sold-09.png",
        "assets/zzs/sold-010.png",
        "assets/zzs/sold-011.png",
        "assets/zzs/sold-013.png",
        "assets/zzs/sold-014.png",
        "assets/zzs/sold-012.png",
        "assets/zzs/sold-015.png",
        "assets/zzs/sold-016.png",
      ],
      images2: [
        "assets/zzs/new4.png",
        "assets/zzs/new5.png",
        "assets/zzs/new6.png",
        "assets/zzs/sold-017.png",
        "assets/zzs/sold-018.png",
        "assets/zzs/sold-019.png",
        "assets/zzs/sold-020.png",
        "assets/zzs/sold-021.png",
        "assets/zzs/sold-022.png",
        "assets/zzs/sold-023.png",
        "assets/zzs/sold-024.png",
        "assets/zzs/sold-025.jpg",
        "assets/zzs/sold-026.jpg",
        "assets/zzs/sold-027.jpg",
        "assets/zzs/sold-028.jpg",
        "assets/zzs/sold-029.jpg",
        "assets/zzs/sold-030.jpg",
        "assets/zzs/sold-031.jpg",
        "assets/zzs/sold-032.jpg",
      ],
      images3: [
        "assets/zzs/new7.png",
        "assets/zzs/new8.png",
        "assets/zzs/new9.png",
        "assets/zzs/sold-033.jpg",
        "assets/zzs/sold-034.jpg",
        "assets/zzs/sold-035.jpg",
        "assets/zzs/sold-036.jpg",
        "assets/zzs/sold-037.jpg",
        "assets/zzs/sold-038.jpg",
        "assets/zzs/sold-039.jpg",
        "assets/zzs/sold-040.jpg",
        "assets/zzs/sold-041.jpg",
        "assets/zzs/sold-043.jpg",
        "assets/zzs/sold-044.jpg",
        "assets/zzs/sold-045.jpg",
        "assets/zzs/sold-046.jpg",
        "assets/zzs/sold-047.jpg",
        "assets/zzs/sold-048.jpg",
      ],
      images4: [
        "assets/zzs/new10.png",
        "assets/zzs/new11.png",
        "assets/zzs/sold-049.jpg",
        "assets/zzs/sold-050.jpg",
        "assets/zzs/sold-051.jpg",
        "assets/zzs/sold-052.jpg",
        "assets/zzs/sold-053.jpg",
        "assets/zzs/sold-054.jpg",
        "assets/zzs/sold-055.jpg",
        "assets/zzs/sold-056.jpg",
        "assets/zzs/sold-057.jpg",
        "assets/zzs/sold-058.jpg",
        "assets/zzs/sold-059.jpg",
        "assets/zzs/sold-060.jpg",
        "assets/zzs/sold-061.jpg",
        "assets/zzs/sold-062.jpg",
        "assets/zzs/sold-063.jpg",
      ],
      images5: [
        "assets/zzs/new13.png",
        "assets/zzs/sold-065.jpg",
        "assets/zzs/sold-066.jpg",
        "assets/zzs/sold-067.jpg",
        "assets/zzs/sold-069.jpg",
        "assets/zzs/sold-080.jpg",
        "assets/zzs/sold-070.jpg",
        "assets/zzs/sold-071.jpg",
        "assets/zzs/sold-072.jpg",
        "assets/zzs/sold-073.jpg",
        "assets/zzs/sold-074.jpg",
        "assets/zzs/sold-075.jpg",
        "assets/zzs/sold-076.jpg",
        "assets/zzs/sold-077.jpg",
        "assets/zzs/sold-078.jpg",
        "assets/zzs/sold-079.jpg",
        "assets/zzs/sold-064.jpg",
      ],
    };
  },
  methods: {
    sign() {
      this.$router.push("/hyticket");
    },
    handleScroll(e) {
      if (isMobile()) {
        this.aboutCoreShow = true;
        this.aboutjiabin = true;
        this.aboutzzs = true;
        this.numItemShow = true;
        // this.aboutP6 = true;
      } else {
        this.currentScroll = window.pageYOffset; //表示当前滚动的位置
        // this.currentScroll = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop //表示当前滚动的位置
        this.aboutCoreShow =
          this.currentScroll >= this.$refs.huiyi.offsetTop - 950; //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.aboutjiabin =
          this.currentScroll >= this.$refs.jiabin.offsetTop - 950; //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.aboutzzs = this.currentScroll >= this.$refs.zzs.offsetTop - 950; //当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.numItemShow = this.currentScroll >= 100;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/simpleAnimation.scss";
@import "@/assets/css/common.scss";
@import "hover.css";

//背景图
.total {
  font-family: PuHuiTi;
  font-size: 0.1rem;
  color: #333333;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  resize: both;
  overflow: auto;
}
.bg {
  width: 100%;
  height: 350px;
  position: relative;
}

.ljgd {
  font-size: 0.12rem;
  background-color: #ffcc02;
  border: 1px solid #ffcc02;
  width: 82px;
  height: 22px;
  left: 45%;
  top: 75%;
  position: absolute;
  cursor: pointer;
  transition: 0.1s all;
  //font-family: "阿里妈妈数黑体 Bold";
}

.ljgd:hover {
  background-color: white;

  transition: 0.1s all;
}

//动态导航
.dt-num {
  margin-top: 10%;
  margin-bottom: 5%;
  //border:0.1px solid #ffba27;
}

.num-ui {
  display: flex;
  justify-content: center;
  margin-left: 5px;

  .ui-item {
    display: flex;
    align-items: center;

    justify-content: center;
    width: 78px;
    height: 30px;

    //border: 0.1px solid red;

    img {
      width: 18px;
      height: 18px;
    }
  }
}

.num-dh {
  //border: 0.1px solid darkcyan;
  display: flex;
  //box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.num-item {
  width: 78px;
  //border: 0.1px solid red;
}

.num-item-sz {
  width: 100%;
  font-weight: bold;
  font-size: 0.25rem;

  color: #ffcc02;
  //border: 0.1px solid rebeccapurple;
}

.num-item-wz {
  font-size: 0.11rem;
  font-family: weiruan;
  color: #4b4b4b;
  margin-top: 5%;
  //border: 0.1px solid darkorange;
}
//会议亮点
.hyld-tp {
  display: flex;
  width: 100%;
  //border: 0.1px solid deeppink;

  .tp-item {
    overflow: hidden;
    height: 128px;
    width: 247.5px;
    position: relative;
  }
  img {
    width: 247.5px;
    height: 100%;
  }

  .tp-zzc {
    width: 100%;
    height: 150px;
    color: #fff;
    font-size: 0.18rem;
    top: 0%;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateY(100%);
    transition: all 0.5s;
    position: absolute;
    background-color: rgba(51, 51, 51, 0.5);
    z-index: 2;
  }

  .tp-item:hover {
    .tp-zzc {
      transform: translateY(0);
    }
    img {
      transform: scale(1.1);
      transition: all 1s;
    }
  }
}

/*
//soldout新引响
    .double{
        width: 100%;
        //border: .1px solid deeppink;
        display: flex;

        height: 300px;
        margin-top: 5%;
    }

    .double:hover .tp-img{
        -webkit-filter: grayscale(100%); !* Chrome, Safari, Opera *!
        filter: grayscale(20%);
        transform:rotate(0deg);
        transition: 0.2s all;
    }

    .double-tp{
        width: 240px;
        height: 270px;
        margin-top: 10px;
        margin-left: 10px;
        background-color: #42e7fe;

        img{
            width: 240px;
            height: 270px;
            transition: 0.2s;
            -webkit-filter: grayscale(100%); !* Chrome, Safari, Opera *!
            filter: grayscale(80%);
            transform:rotate(-5deg);
        }
    }

    .double-wz{

        width: 220px;
        display: flex;
        margin-top: 15%;
        flex-direction: column;
        align-items: center;
        line-height: 12px;
        text-align: justify;
        margin-left: 10%;
        //border: 0.1px solid #42e7fe;
    }
*/

//颜色窗
.ysc {
  width: 100%;
  margin-top: 5%;
  height: 230px;
  //border: 0.1px solid #42e7fe;
  overflow: hidden;
  transition: 0.5s;
  img {
    width: 100%;
    height: 230px;
  }
}

.ysc:hover {
  transition: 0.5s;
  box-shadow: 0 2px 12px 0 rgb(176, 175, 175);
}
//演讲嘉宾
.speeker-info {
  width: 100%;
  height: 570px;
  margin-top: 27px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /*border: 1px solid blanchedalmond;*/
}

.row {
  width: 100%;
  height: 135px;
  display: flex;
  justify-content: space-between;
  /*border: 0.8px solid #02ffef;*/
}

.row-item {
  width: 17%;
  height: 100%;
  //border: 0.2px solid #ffba27;
}

.cover {
  width: 73px;
  height: 80px;
  border-radius: 5px;
  overflow: hidden;
}
.row-item img {
  width: 100%;
  height: 100%;
}

.item-wz {
  margin-top: 3%;
  display: flex;
  font-size: 0.1rem;
  flex-direction: column;
}

.speeker-name {
  font-size: 0.11rem;
  color: #ffcc02;
}

//赞助商
.xlzz {
  width: 100%;
  height: auto;
  //border:1px solid red;

  margin-top: 5%;
}

.xlzz-bottom {
  width: 100%;
  display: flex;
  margin-top: 5%;
  flex-direction: column;
  position: relative;
}

.xlzz-bottom-xh {
  width: 20%;
  height: 100%;
  position: absolute;
  right: 0;
  z-index: 2;
  background-image: linear-gradient(
    to left,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.08)
  );
}
.xlzz-bottom-xh2 {
  width: 20%;
  height: 100%;
  position: absolute;
  z-index: 2;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.08)
  );
}

//弹性
.tx {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ty-font {
  line-height: 12px;
  letter-spacing: 0.2px;
}
video {
  width: 100%;
  height: 100%;
  object-fit: cover; //修复视频有黑边bug
  outline: none !important; //修复视频有黑边bug
  mix-blend-mode: darken; //修复视频有黑边bug
}
video:focus {
  outline: none !important; //修复视频有黑边bug
}
</style>
